import { Injectable } from '@angular/core';
import { Permission } from '../../shared/models/permission';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService extends BaseService<Permission> {

  constructor(protected override http: HttpClient) {
    super(http, 'permission');
  }
}
